if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cascading-formatted-message.production.js');
} else {
  module.exports = require('./cascading-formatted-message.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/cascading-formatted-message/dist/es/cascading-formatted-message.js
// module id = 503
// module chunks = 0